module.exports = __webpack_public_path__ + "img/al-jerek-torrijas-saved-by-the-bell.0c39dbb.jpg";